import { render, staticRenderFns } from "./Standard-Button.vue?vue&type=template&id=2691532a&scoped=true"
import script from "./Standard-Button.vue?vue&type=script&lang=js"
export * from "./Standard-Button.vue?vue&type=script&lang=js"
import style0 from "./Standard-Button.vue?vue&type=style&index=0&id=2691532a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691532a",
  null
  
)

export default component.exports